import Layout, { CardStyled, HeadStyled } from '../../components/Layout';
import EstadoCarga from '../../components/EstadoCarga';
import { fetchObrasList, selector } from '../../redux/slices/ObrasSlice';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { deleteAPI } from '../../api';
import { formatCorto } from '../../utils/hora';

// Hay ~1500 obras históricas: se pintan por bloques para que la página responda enseguida.
export const BLOQUE = 100;

export default function App() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { ObrasList, loading, error } = useSelector(selector);
    const [searchText, setSearchText] = useState('');
    const [visibles, setVisibles] = useState(BLOQUE);

    useEffect(() => {
        dispatch(fetchObrasList());
    }, [dispatch])

    async function handleDelete(e, id) {
        e.preventDefault();
        e.stopPropagation();
        if (window.confirm("Se borrará la función entera. Está operación no se puede deshacer. ¿Desea continuar?")) {
            await deleteAPI('obras', id);
        }
        navigate(0)
    }

    const onChangeSearchText = (e) => {
        setSearchText(e.target.value);
        setVisibles(BLOQUE);
    }

    const listFiltered = useMemo(() => {
        const texto = searchText.trim().toLowerCase();
        return texto ? ObrasList.filter(obra => obra.titulo?.toLowerCase().includes(texto)) : ObrasList;
    }, [searchText, ObrasList]);

    function openEdit(e, id) {
        e.preventDefault();
        navigate(`/sala/${id}`)
    }

    return (
        <Layout>
            <input onChange={onChangeSearchText} placeholder='Buscar por título'></input>
            <HeadStyled>
                <span style={{ width: "65%" }}>Título</span>
                <span style={{ width: "27%" }}>Última función</span>
                <span style={{ width: "8%" }}>Borrar</span>
            </HeadStyled>
            <EstadoCarga loading={loading} error={error} onRetry={() => dispatch(fetchObrasList())}>
                {listFiltered.length === 0 ? <h2>Sin obras que mostrar</h2> : <>
                    {listFiltered.slice(0, visibles).map(obra => (
                        <CardStyled key={obra._id} onClick={(e) => { openEdit(e, obra._id) }}>
                            <span style={{ width: "65%" }}>{obra.titulo}</span>
                            <span style={{ width: "27%" }}>{obra.ultimaFecha ? formatCorto(obra.ultimaFecha) : 'Sin funciones'}</span>
                            <button
                                onClick={(e) => handleDelete(e, obra._id)}
                                style={{ width: "5%" }}>❌</button>
                        </CardStyled>
                    ))}
                    {listFiltered.length > visibles && (
                        <p>
                            Mostrando {visibles} de {listFiltered.length}.{' '}
                            <button type="button" onClick={() => setVisibles(v => v + BLOQUE)}>Mostrar más</button>{' '}
                            <button type="button" onClick={() => setVisibles(listFiltered.length)}>Mostrar todas</button>
                        </p>
                    )}
                </>}
            </EstadoCarga>
        </Layout>
    );
}
